import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminApi } from '../../utils/adminApi';

function ProtectedRoute({ children }) {
  const [status, setStatus] = useState('checking'); // checking | authed | unauthed

  useEffect(() => {
    let mounted = true;
    adminApi
      .me()
      .then(() => mounted && setStatus('authed'))
      .catch(() => mounted && setStatus('unauthed'));
    return () => {
      mounted = false;
    };
  }, []);

  if (status === 'checking') {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (status === 'unauthed') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

export default ProtectedRoute;
